/* istanbul ignore file */
import { useLocation, useNavigate, matchPath } from "react-router-dom";
import { MainRoutes } from "ui/common/router/MainRouter.types";

export default function useTitleBackButton() {
    const navigate = useNavigate();
    const location = useLocation();

    const backButtonRules: Array<{ pattern: string; action: () => void }> = [
        { pattern: MainRoutes.GIFT_CARDS_DETAILS, action: () => navigate(-1) },
        { pattern: MainRoutes.GIFT_CARDS_PURCHASED, action: () => navigate(-1) },
    ];

    function onClickBackButton() {
        const { pathname } = location;

        const matchedRule = backButtonRules.find((rule) => matchPath({ path: rule.pattern, end: true }, pathname));

        if (matchedRule) {
            matchedRule.action();
        } else {
            navigate(MainRoutes.MAIN);
        }
    }

    return { onClickBackButton };
}
